/* eslint-disable eqeqeq */
/* eslint-disable dot-notation */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */
/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */
/* eslint-disable camelcase */
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Label as Lable2 } from 'reactstrap';
import { useState, useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import RepeatOneIcon from '@mui/icons-material/RepeatOne';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import {
  Container,
  TextField,
  Autocomplete,
  FormControl,
  Stack,
  Grid,
  Snackbar,
  Alert,
  Slide,
  Dialog,
  LinearProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  IconButton,
  Checkbox,
  TableCell,
  Paper,
  FormControlLabel
} from '@mui/material';
import tableCellClasses from '@mui/material/TableCell';
import styled from '@emotion/styled';
import { Link, useNavigate, useParams } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import useResponsive from '../hooks/useResponsive';
import NoimageFound from '../media/noimage.jpg';
import imagepreview from '../media/time.png';
import './stylemod.css';
import axios from '../axiosConfig';

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableHeader = styled(TableCell)(({ theme }) => ({
  // backgroundColor: theme.palette.info.main,
  backgroundColor: '#6482AD',
  color: theme.palette.common.white,
}));

function formatDate(inputDateTime) {
  const isoDate = new Date(inputDateTime);

  const day = isoDate.getUTCDate().toString().padStart(2, '0');
  const month = (isoDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = isoDate.getUTCFullYear();

  let hour = isoDate.getUTCHours();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour %= 12;
  hour = hour || 12;

  const minute = isoDate.getUTCMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year}`;
}

export default function AddTimeStudy(props) {
  const mdUp = useResponsive('up', 'md');
  const { id } = useParams();
  const { type } = useParams();
  // console.log(id === undefined);
  const [idState, setIdState] = useState(id);
  const classes = useStyles();
  const navigate = useNavigate();
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  // OPERATIONAL REQUIREMNETS STATES
  const [currentDate, setCurrentDate] = React.useState(new Date());
  const [editRefId, setEditRefId] = React.useState('');
  const [headerData, setHeaderData] = useState([]);
  const [buyerSelected, setbuyerSelected] = React.useState('');
  const [BuyerData, setBuyerData] = useState([]);
  const [intialUserData, setInitialUserData] = useState([]);
  const [UserData, setUserData] = useState([]);
  const [allRecordsData, setallRecordsData] = useState([]);
  const [obSelected, setObSelected] = React.useState('');
  const [garmentsData, setGarmentsData] = useState([]);
  const [garmentSelected, setGarmentSelected] = React.useState('');
  const [styleDesc, setStyleDesc] = React.useState('');
  const [styleNum, setStyleNum] = React.useState('');
  const [orderQty, setOrderQty] = React.useState('');
  const [OBorderQty, setOBOrderQty] = React.useState('');
  const [dayTarget, setDayTarget] = React.useState('');
  const [shiftHours, setShiftHours] = React.useState('');
  const [targetPerHour, setTargetPerHour] = React.useState(dayTarget / shiftHours);
  const [workingDays, setWorkingDays] = React.useState('');
  const [planLineEff, setPlanLineEff] = React.useState('');
  const [machinehandEff, setMachinehandEff] = React.useState('');
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = React.useState('');
  const [lineData, setLineData] = useState([]);
  const [lineSelected, setLineSelected] = React.useState('');
  const [selectedImageFile, setSelectedImageFile] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [dialogOpenPicker, setDialogOpenPicker] = useState(false);
  const [HeaderandDetailID, setHeaderandDetailID] = useState('');
  // ADD OPRATIONS STATES
  const [machineTypeCounts, setMachineTypeCounts] = useState([]);
  const [OperationData, setOperationData] = useState([]);
  const [opGroupData, setOpGroupData] = useState([]);
  const [operationDetails, setOperationDetails] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  // others
  const [alertType, setAlertType] = useState('success');
  const [openAlert, setopenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [openLoader, setOpenLoader] = useState(false);
  const [machineDetailsOpen, setMachineDetailsOpen] = useState(false);
  const [machineData, setMachineData] = useState([]);

  const [targetDay, setTargetDay] = useState(0);
  const [selectedOperators, setSelectedOperators] = useState({});
  const autocompleteRefs = useRef([]);
  const unitRefs = useRef();
  const lineRefs = useRef();
  const [loadAllEmployees, setLoadAllEmployees] = useState(false);

  const [TSQuantity, setTSQuantity] = useState('');
  const [dupEmpinDailyProd, setDupEmpinDailyProd] = useState(false);
  const [removeDuplicates, setRemoveDuplicates] = useState('N');

  const [fieldErrors, setFieldErrors] = React.useState({
    // opertional requirements
    obSelected: false,
    buyerSelected: false,
    garmentSelected: false,
    styleDesc: false,
    styleNum: false,
    orderQty: false,
    dayTarget: false,
    shiftHours: false,
    targetPerHour: false,
    workingDays: false,
    planLineEff: false,
    machinehandEff: false,
    lineSelected: false,
    selectedImageFile: false,
    Operatorissue: false,
    unitSelected: false,
  });

  const resetFields = () => {
    setObSelected('');
    setbuyerSelected(null);
    setGarmentSelected(null);
    setStyleDesc('');
    setStyleNum('');
    setOrderQty('');
    setDayTarget('');
    setShiftHours('');
    setTargetPerHour('');
    setWorkingDays('');
    setPlanLineEff('');
    setMachinehandEff('');
    setLineSelected('');
  };


  // API Integration
  React.useEffect(() => {
    getAllOBRecords();
    GetAllOperationMstData();
    GetAllMachineMstData();
    GetAllActiveBuyers();
    GetAllActiveGarmentMst();
    GetAllActiveOperationGrpData();
    GetallUser();
    GetAllActiveProductionUnits();
    GetGradeMstData();
    GetOneControl(sessionStorage.getItem('factoryID'));
  }, []);

  useEffect(() => {
    setTargetDay(
      operationDetails.length > 0
        ? (() => {
          const result = operationDetails.find((currentObject) => currentObject.FinalOperation === 'Y');
          return result ? (Number(result.HoursTarget) * Number(result.NoofOperation)).toFixed(3) * shiftHours : 0;
        })()
        : 0
    );
  }, [targetDay, operationDetails]);

  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const GetOneControl = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetOneControlCenter/${id}/${sessionStorage.getItem('CompanyId')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      if (res.data.length > 0) {
        res.data.forEach((data) => {
          setDupEmpinDailyProd(data.DuplicateEmpinDailyProd === 'Y');
        });
      }
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getAllOBRecords = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllObHeader', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setallRecordsData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    }
  };

  // get all Operation Request
  const GetAllOperationMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllOperationMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperationData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Buyers Request
  const GetAllActiveBuyers = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveBuyers', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setBuyerData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Operation Request
  const GetAllActiveGarmentMst = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveGarmentMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setGarmentsData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all group Request
  const GetAllActiveOperationGrpData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationGrpData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOpGroupData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const filteredDataPicker = allRecordsData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  // get all machine data
  const GetAllMachineMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllMachineMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setMachineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all line data
  const GetAllActiveLineMstData = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveLineMstData/${sessionStorage.getItem('UserID')}/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all line data
  const GetAllActiveLineMstDataEdit = async (id, id1) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveLineMstData/${sessionStorage.getItem('UserID')}/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const selectedLine = res.data.find((obj) => obj.Line_id === id1);
      setLineSelected(selectedLine);
      setLineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  useEffect(() => {
    if (operationDetails.length !== 0) {
      const machineTotals = {};
      operationDetails.forEach((item) => {
        // console.log(item);
        const machineName = item.Machine_name;
        if (!machineTotals[machineName]) {
          machineTotals[machineName] = { NoofMachines: 0, Count: 0 };
        }
        machineTotals[machineName].NoofMachines += parseFloat(item.NoofMachines);
        machineTotals[machineName].Count += 1; // Counting occurrences
      });

      // Convert the totals object to an array
      const resultArray = Object.keys(machineTotals).map((machineName) => ({
        Machine_name: machineName,
        NoofMachines: machineTotals[machineName].NoofMachines,
        Count: machineTotals[machineName].Count,
      }));
      // console.log(resultArray);
      setMachineTypeCounts(resultArray);
    }
  }, [operationDetails, machineData, id]);

  // pre fill data for editing screen
  useEffect(() => {
    const GetoneObHeader = async (ids, IsRepeat) => {
      setOpenLoader(true);
      try {
        const res = await axios.instance.get(
          `${id === undefined ? (IsRepeat ? 'GetoneTsHeader' : 'GetoneObHeader') : 'GetoneTsHeader'}/${ids}`,
          {
            headers: { Authorization: tokent, 'Content-Type': 'application/json' },
          }
        );
        const data = res.data;
        setHeaderData(res.data[0]);
        const filteredByLine = intialUserData.filter((data) => Number(data.LineId) === Number(res.data[0].Line_id));
        setUserData(filteredByLine);
        fetchAndSetOperations(ids, res.data[0], IsRepeat);
        data.forEach((editDataonID) => {
          const {
            TsNo,
            Buyerid,
            GarmentDescription,
            StyleDescription,
            StyleNumber,
            OrderQty,
            DayTarget,
            ShiftHour,
            Weekdays,
            LineEffecient,
            EstimatedEffecient,
            Batchid,
            OBImage,
            Unit_Id,
            TsDate,
            OBorderQty,
          } = editDataonID;
          const selectedBuyer = BuyerData.find((obj) => obj.Buyer_Id === Buyerid);
          const selectedGarmentDesc = garmentsData.find((ste) => ste.Garment_Id === GarmentDescription);
          const selectedLine1 = unitData.find((obj) => Number(obj.Unit_Id) === Number(Unit_Id));
          GetAllActiveLineMstDataEdit(Unit_Id, Batchid);
          setEditRefId(TsNo);
          setbuyerSelected(selectedBuyer);
          setGarmentSelected(selectedGarmentDesc);
          setStyleDesc(StyleDescription);
          setStyleNum(StyleNumber);
          // setOrderQty(OrderQty);
          setOrderQty(id === undefined ? (IsRepeat ? OrderQty : '') : OrderQty)
          setOBOrderQty(OBorderQty);
          setDayTarget(DayTarget);
          setShiftHours(ShiftHour);
          setTargetPerHour(DayTarget / ShiftHour);
          setWorkingDays(Weekdays);
          setPlanLineEff(LineEffecient);
          setMachinehandEff(EstimatedEffecient);
          // setCurrentDate(TsDate);
          setCurrentDate(id === undefined ? (IsRepeat ? TsDate : new Date()) : TsDate)
          // setLineSelected(selectedLine);
          setUnitSelected(selectedLine1);
          setSelectedImageFile(`${axios.baseURL}OperationBulletin/${OBImage}`);
          setImagePreview(`${axios.baseURL}OperationBulletin/${OBImage}`);
          setTSQuantity(id === undefined ? (IsRepeat ? OrderQty : '') : OrderQty)
        });
        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setOpenLoader(false);
      } finally {
        setOpenLoader(false);
      }
    };
    const fetchAndSetOperations = async (ids, headerdatas, IsRepeat) => {
      try {
        const response = await axios.instance.get(
          `${id === undefined ? (IsRepeat ? 'GetoneTsDetail' : 'GetoneObDetail') : 'GetoneTsDetail'}/${ids}`,
          {
            headers: { Authorization: tokent, 'Content-Type': 'application/json' },
          }
        );
        if (response.data && response.data.length > 0) {
          const receivedData = response.data;

          // Map received data to the desired format
          const newAddedOperations = receivedData.map((operation, index) => {
            return {
              Operationid: operation.Operationid,
              OperationName: operation.OperationName,
              GradeId: operation.GradeId,
              Mctypeid: operation.Mctype,
              MachineType: operation.MachineType,
              Startch1: operation.Startch1,
              Startch2: operation.Startch2,
              Estimatedsmv: operation.Estimatedsmv,
              Actucalsmv: operation.Actucalsmv,
              FinalOperation: operation.FinalOperation,
              FinalSMV: id ? (operation.finalSMV !== 0 ? operation.finalSMV : 0) : 0,

              // Below NoofMachines and NoofOperation is commented by harel on 24-08-2024 if both is not equal to then
              // assign the saved value because if operator is changed manually below code will not affect
              NoofMachines: id
                ? operation.finalSMV !== 0
                  ? (() => {
                    const calculatedValue = Math.round(
                      headerdatas.DayTarget /
                      Math.floor(
                        (((60 / parseFloat(operation.finalSMV)) * Number(headerdatas.LineEffecient)) / 100) *
                        headerdatas.ShiftHour
                      )
                    );
                    return calculatedValue !== operation.NoofMachines ? operation.NoofMachines : calculatedValue;
                  })()
                  : operation.NoofMachines
                : operation.NoofMachines,
              NoofOperation: id
                ? operation.finalSMV !== 0
                  ? (() => {
                    const calculatedValue = (
                      headerdatas.DayTarget /
                      Math.floor(
                        (((60 / parseFloat(operation.finalSMV)) * Number(headerdatas.LineEffecient)) / 100) *
                        headerdatas.ShiftHour
                      )
                    ).toFixed(3);
                    return calculatedValue !== operation.NoofOperation ? operation.NoofOperation : calculatedValue;
                  })()
                  : operation.NoofOperation
                : operation.NoofOperation,
              HoursTarget: id
                ? operation.finalSMV !== 0
                  ? Math.floor(
                    (operation.finalSMV !== 0
                      ? (60 / parseFloat(operation.finalSMV)) * Number(headerdatas.LineEffecient)
                      : 0) / 100
                  )
                  : operation.HoursTarget
                : operation.HoursTarget,
              Daytarget: id
                ? operation.finalSMV !== 0
                  ? Math.floor(
                    (operation.finalSMV !== 0
                      ? (60 / parseFloat(operation.finalSMV)) * Number(headerdatas.LineEffecient)
                      : 0) / 100
                  ) * headerdatas.ShiftHour
                  : operation.Daytarget
                : operation.Daytarget,
              ThirdLength: operation.ThirdLength,
              SPI: operation.Stitch_per_Inch,
              RMP: operation.RMP,
              emp_role: operation.emp_role,
              CreatedBy: sessionStorage.getItem('UserID'),
              threadinch: operation.threadinch,
              threadConsumptionFactor: operation.threadConsumptionFactor,
              Operatorid: operation.Operatorid,
              Machine_name: operation.Machine_name,
              Snotdtl: id ? operation.Snotdtl : index + 1,
            };
          });

          setOperationDetails(newAddedOperations);
          // console.log(newAddedOperations,'newAddedOperations')
        }
      } catch (error) {
        console.error('Error fetching operations data:', error);
      }
    };
    // console.log(idState, 'idState', HeaderandDetailID);
    if (HeaderandDetailID) {
      GetoneObHeader(HeaderandDetailID, true);
      // fetchAndSetOperations(idState);
    } else if (idState) {
      GetoneObHeader(idState, false);
    }

  }, [id, idState, BuyerData, garmentsData, HeaderandDetailID, unitData, intialUserData]);


  const validateOpeartinRequirements = () => {
    const errors = {
      buyerSelected: !buyerSelected,
      garmentSelected: !garmentSelected,
      styleDesc: !styleDesc,
      styleNum: !styleNum,
      orderQty: !orderQty,
      dayTarget: !dayTarget,
      shiftHours: shiftHours === '',
      targetPerHour: targetPerHour === '',
      workingDays: workingDays === '',
      planLineEff: planLineEff === '',
      machinehandEff: machinehandEff === '',
      lineSelected: !lineSelected,
      selectedImageFile: !selectedImageFile,
      // Operatorissue: operationDetails.filter((data) => data.Operatorid === undefined).length !== 0,
      unitSelected: !unitSelected,
    };
    setFieldErrors((prevFieldErrors) => ({ ...prevFieldErrors, ...errors }));
    return !Object.values(errors).some(Boolean);
  };

  const handleFormSubmit = () => {
    if (!unitSelected || !unitSelected.Unit_Id) {
      setAlertType('warning');
      setAlertMessage('Please Select Unit');
      setopenAlert(true);
      unitRefs.current?.focus();
      return;
    }
    if (!lineSelected) {
      setAlertType('warning');
      setAlertMessage('Please Select Line');
      setopenAlert(true);
      lineRefs.current?.focus();
      return;
    }

    // const allComplete =
    //   operationDetails.filter((data) => data.Operatorid === undefined || data.Operatorid === null).length === 0;
    const allComplete = true
    if (allComplete) {
      if (!validateOpeartinRequirements()) {
        return;
      }

      let modifiedUrl;

      const originalUrl = selectedImageFile;
      const baseUrl = `${axios.baseURL}OperationBulletin/`;
      if (typeof originalUrl !== 'object') {
        modifiedUrl = originalUrl.replace(baseUrl, '');
      } else {
        modifiedUrl = selectedImageFile;
      }

      const formData = new FormData();
      formData.append('TsDate', new Date());
      formData.append('ObNo', 1);
      formData.append('Buyerid', buyerSelected.Buyer_Id);
      formData.append('ObRef', idState);
      formData.append('StyleDescription', styleDesc);
      formData.append('StyleNumber', styleNum);
      formData.append('GarmentDescription', headerData.GarmentDescription);
      formData.append('Batchid', lineSelected.Line_id);
      formData.append('DayTarget', dayTarget);
      formData.append('ShiftHour', shiftHours);
      formData.append('Weekdays', workingDays);
      formData.append('LineEffecient', planLineEff);
      formData.append('EstimatedEffecient', machinehandEff);
      formData.append('OrderQty', orderQty);
      formData.append('TsImage', modifiedUrl);
      formData.append('ProductionUnit', unitSelected.Unit_Id);
      formData.append('CreatedBy', sessionStorage.getItem('UserID'));
      formData.append('CompanyId', sessionStorage.getItem('CompanyId'));
      formData.append('FiscalYear', sessionStorage.getItem('FiscalYear'));

      if (!id) {
        addTimeAndStudy(formData);
      } else {
        updateTimeAndStudy(id, formData);
      }
    } else {
      setAlertType('warning');
      setAlertMessage('Please select Operator');
      setopenAlert(true);
      for (let i = 0; i < operationDetails.length; i += 1) {
        if (operationDetails[i].Operatorid === undefined || operationDetails[i].Operatorid === null) {
          const inputElement = autocompleteRefs.current[i]?.querySelector('input');
          if (inputElement) {
            inputElement.focus();
            break;
          }
        }
      }
    }
    setTimeout(() => {
      setopenAlert(false);
    }, 2000);
  };

  const addTimeAndStudy = (newData) => {
    setOpenLoader(true);

    return axios.instance
      .post('/InsertTsHeader', newData, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((headerRes) => {
        if (headerRes.data && headerRes.data.length > 0 && headerRes.data[0].Tsheaderid !== undefined) {
          const Tsheaderid = headerRes.data[0].Tsheaderid;
          const detailPromises = operationDetails.map((obj, index) => {
            const insertData = {
              ...obj,
              TsHeaderid: Tsheaderid,
              Snotdtl: index + 1,
            };

            return axios.instance.post('/InsertTsDetail', insertData, {
              headers: {
                Authorization: tokent,
                'Content-Type': 'application/json',
              },
            });
          });

          return Promise.all(detailPromises)
            .then((detailRes) => {
              setAlertType('success');
              setAlertMessage('Data Added Successfully!');
              setopenAlert(true);
              resetFields();
              setTimeout(() => {
                setopenAlert(false);
                setOpenLoader(false);
                navigate('/dashboard/manage/time_and_study');
              }, 2000);
              return detailRes;
            })
            .catch((error) => {
              console.error('Error adding detail data:', error);
              setAlertType('error');
              setAlertMessage('Failed to add detail data.');
              setOpenLoader(false);
              setopenAlert(true);
              return Promise.reject(error);
            });
        }
        setAlertType('error');
        setAlertMessage("Oops! Can't add this data...");
        setopenAlert(true);
        setOpenLoader(false);
        return Promise.reject(new Error('Header insert failed'));
      })
      .catch((error) => {
        console.error('Error adding new Data:', error);
        setAlertType('error');
        setAlertMessage('Failed to add the new Data.');
        setOpenLoader(false);
        setopenAlert(true);
        return Promise.reject(error);
      });
  };

  // put Request to edit record
  const updateTimeAndStudy = async (id, newData) => {
    setOpenLoader(true);

    return axios.instance
      .put(`/UpdateTsHeader/${id}`, newData, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((headerRes) => {
        if (headerRes.data && headerRes.data.length > 0 && headerRes.data[0].Tsheaderid !== undefined) {
          const Tsheaderid = id;

          const detailPromises = operationDetails.map((obj) => {
            const insertData = {
              ...obj,
              TsHeaderid: Tsheaderid,
              finalSMV: obj.FinalSMV,
              FinalOperation: obj.FinalOperation,
            };

            return axios.instance
              .post('/InsertTsDetail', insertData, {
                headers: {
                  Authorization: tokent,
                  'Content-Type': 'application/json',
                },
              })
              .then((res) => {
                // console.log(res.data);
              });
          });

          return Promise.all(detailPromises)
            .then((detailRes) => {
              setAlertType('success');
              setAlertMessage('Data Updated Successfully!');
              setopenAlert(true);
              resetFields();
              setTimeout(() => {
                setopenAlert(false);
                setOpenLoader(false);
                navigate('/dashboard/manage/time_and_study');
              }, 2000);
              return detailRes;
            })
            .catch((error) => {
              console.error('Error updating detail data:', error);
              setAlertType('error');
              setAlertMessage('Failed to Updated detail data.');
              setOpenLoader(false);
              setopenAlert(true);
              return Promise.reject(error);
            });
        }
        setAlertType('error');
        setAlertMessage("Oops! Can't add this data...");
        setopenAlert(true);
        setOpenLoader(false);
        new Error('Header insert failed');
      })
      .catch((error) => {
        // Handle error during header insertion
        console.error('Error adding new Data:', error);
        setAlertType('error');
        setAlertMessage('Failed to add the new Data.');
        setOpenLoader(false);
        setopenAlert(true);
        return Promise.reject(error);
      });
  };

  const handleMachineDetailsOpen = () => {
    setMachineDetailsOpen(true);
  };

  const handleMachineDetailsClose = () => {
    setMachineDetailsOpen(false);
  };

  function handleDetailChange(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = Number(value);
    setOperationDetails(updatedDetails);

    if (field === 'FinalSMV') {
      recalculateDependentFields(index);
    }
  }

  function recalculateDependentFields(index) {
    const detail = operationDetails[index];
    const estimatedSMV =
      detail.FinalSMV === '' || parseFloat(detail.FinalSMV) === 0
        ? parseFloat(detail.Actucalsmv)
        : parseFloat(detail.FinalSMV);

    if (!Number.isNaN(estimatedSMV)) {
      const sumofActucalsmv = estimatedSMV;
      UpdateHoursTarget(index, 'HoursTarget', (estimatedSMV !== 0 ? (60 / estimatedSMV) * planLineEff : 0) / 100);
    }
  }

  function UpdateHoursTarget(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = Math.floor(value);
    setOperationDetails(updatedDetails);
    UpdateDaytarget(index, 'Daytarget', Math.floor(value) * Number(shiftHours));
  }

  function UpdateDaytarget(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = Math.floor(value);
    setOperationDetails(updatedDetails);

    UpdateNoofOperation(index, 'NoofOperation', (Number(dayTarget) / Math.floor(value)).toFixed(3));
    UpdateNoofMachines(
      index,
      'NoofMachines',
      // Math.round((dayTarget / Math.floor(value)).toFixed(3))
      (value === 0 ? 0 : dayTarget / Math.floor(value)).toFixed(3) < 0.5 &&
        (value === 0 ? 0 : dayTarget / Math.floor(value)).toFixed(3) > 0
        ? 1
        : Math.round((value === 0 ? 0 : dayTarget / Math.floor(value)).toFixed(3))
    );
  }

  function UpdateNoofOperation(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = value;
    setOperationDetails(updatedDetails);
  }

  function UpdateNoofOperation1(index, field, value) {
    // console.log(index, field, value);
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = value;
    setOperationDetails(updatedDetails);

    const updatedDetails1 = [...operationDetails];
    updatedDetails[index]['NoofMachines'] =
      (Number(value) === 0 ? 0 : Number(value)).toFixed(3) < 0.5 &&
        (Number(value) === 0 ? 0 : Number(value)).toFixed(3) > 0
        ? 1
        : Math.round((Number(value) === 0 ? 0 : Number(value)).toFixed(3));
    setOperationDetails(updatedDetails1);
  }

  const handleDialogClosePicker = () => {
    setDialogOpenPicker(false);
  };

  function UpdateNoofMachines(index, field, value) {
    const updatedDetails = [...operationDetails];
    updatedDetails[index][field] = value;
    setOperationDetails(updatedDetails);
  }



  // Add this useEffect to initialize selectedOperatorsMap in edit mode
  useEffect(() => {
    if (id && operationDetails.length > 0) {
      // Initialize selectedOperatorsMap with operators from operationDetails
      const initialSelectedOperators = operationDetails
        .filter(detail => detail.Operatorid != null)
        .map(detail => {
          // Find the operator details from initialUserData or UserData
          const operator = intialUserData.find(user =>
            Number(user.UserAccessID) === Number(detail.Operatorid)
          ) || UserData.find(user =>
            Number(user.UserAccessID) === Number(detail.Operatorid)
          );

          return operator ? {
            operatorId: operator.UserAccessID,
            lineId: operator.LineId
          } : null;
        })
        .filter(Boolean); // Remove null values

      setSelectedOperatorsMap(initialSelectedOperators);
    }
  }, [id, operationDetails, intialUserData, UserData]); // Add dependencies

  // Add this state at the top with your other states
  const [selectedOperatorsMap, setSelectedOperatorsMap] = useState([]); // Array of { operatorId, lineId }

  const GetallUser = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllUsers/N', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });

      // Filter users not equal to 'N/A'
      const allUsers = res.data.filter((item) => item.GradeName !== 'N/A');

      // Set initialUserData with all users
      setInitialUserData(allUsers);

      let filteredUsers;
      if (id) {
        // EDIT MODE: Filter by line and exclude already assigned operators from OTHER records
        const assignedOperatorIds = operationDetails
          .map(detail => detail.Operatorid)
          .filter(id => id != null);

        filteredUsers = allUsers.filter((user) =>
          user.LineId === lineSelected?.Line_id &&
          !assignedOperatorIds.includes(user.UserAccessID)
        );
      } else {
        // NEW MODE: Just filter by line
        filteredUsers = allUsers.filter((user) => user.LineId === lineSelected?.Line_id);
      }
      // console.log('UserData from GetallUser',filteredUsers);
      setUserData(filteredUsers);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    }
  };

  const handleDeleteOperation = (index) => {
    const deletedOperation = operationDetails[index];
    const deletedOperatorId = deletedOperation?.Operatorid;

    // Remove the operation from the list
    setOperationDetails((prevDetails) => prevDetails.filter((_, i) => i !== index));

    // If there was an operator assigned to this deleted operation, make them available again
    if (deletedOperatorId) {
      // Find the deleted operator from initialUserData
      const deletedOperator = intialUserData.find(user => user.UserAccessID === deletedOperatorId);

      if (deletedOperator) {
        // Add the operator back to UserData if they belong to the current line
        if (deletedOperator.LineId === lineSelected?.Line_id) {
          setUserData(prevUserData => {
            // Check if operator already exists in UserData to avoid duplicates
            const alreadyExists = prevUserData.some(user => user.UserAccessID === deletedOperatorId);
            if (!alreadyExists) {
              return [...prevUserData, deletedOperator];
            }
            return prevUserData;
          });
        }

        // Also ensure the operator is available in the filtered data
        // This will trigger a re-render of the autocomplete components
        setOperationDetails(prev => [...prev]); // Force re-render
      }
    }
  };

  const handleLoadAllEmployeesToggle = (index) => {
    setLoadAllEmployees(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // const getGradeLabel = (gradeId) => {
  //   const gradeMap = {
  //     1: 'A+',
  //     2: 'A',
  //     3: 'B',
  //     4: 'C',
  //     5: 'D'
  //   };
  //   return gradeMap[gradeId] || 'Unknown';
  // };


  const [gradeData, setGradeData] = useState([]);

  const GetGradeMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllGradeMstData`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setGradeData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };



  const getGradeLabel = (gradeId) => {
    if (!gradeData || gradeData.length === 0) return 'Unknown';

    const found = gradeData.find((item) => item.Grade == gradeId);
    return found ? found.GradeLable : 'Unknown';
  };



  // const getFilteredUserData = (index) => {
  //   const currentOperationGrade = operationDetails[index]?.GradeId;
  //   const currentOperationOperatorId = operationDetails[index]?.Operatorid;

  //   const allSelectedOperatorIds = new Set();

  //   // Add operators from selectedOperatorsMap
  //   selectedOperatorsMap.forEach(operator => {
  //     allSelectedOperatorIds.add(operator.operatorId);
  //   });

  //   // In edit mode, also add operators from other operationDetails
  //   if (id) {
  //     operationDetails.forEach((detail, idx) => {
  //       if (idx !== index && detail.Operatorid != null) {
  //         allSelectedOperatorIds.add(detail.Operatorid);
  //       }
  //     });
  //   }

  //   // Remove current operation's operator to allow re-selection
  //   if (currentOperationOperatorId) {
  //     allSelectedOperatorIds.delete(currentOperationOperatorId);
  //   }

  //   // Determine which user pool to use based on checkbox
  //   let userPool;
  //   if (loadAllEmployees[index]) {
  //     // Use all users from initial data
  //     userPool = intialUserData;
  //   } else {
  //     // Use line-specific users
  //     userPool = UserData;
  //   }

  //   // Filter out other selected operators
  //   let filteredUsers = userPool.filter(user =>
  //     !allSelectedOperatorIds.has(user.UserAccessID)
  //   );

  //   if (currentOperationGrade) {
  //     filteredUsers = filteredUsers.filter((user) => user.GradeId <= currentOperationGrade);

  //     // Sort: first by whether grade matches current operation grade, then by grade descending
  //     filteredUsers = filteredUsers.sort((a, b) => {
  //       // Priority 1: Operators with exact grade match come first
  //       const aIsExactMatch = a.GradeId === currentOperationGrade;
  //       const bIsExactMatch = b.GradeId === currentOperationGrade;

  //       if (aIsExactMatch && !bIsExactMatch) return -1;
  //       if (!aIsExactMatch && bIsExactMatch) return 1;

  //       // Priority 2: Then sort by grade in descending order
  //       return b.GradeId - a.GradeId;
  //     });
  //   }

  //   return filteredUsers;
  // };

  const getFilteredUserData = (index) => {
    const currentOperationGrade = operationDetails[index]?.GradeId;
    const currentOperationOperatorId = operationDetails[index]?.Operatorid;
    const currentLineId = headerData?.Line_id;

    if (dupEmpinDailyProd) {

      const userPool = loadAllEmployees[index] ? intialUserData : UserData;

      // Still apply Assigned + Grade rules
      let filteredUsers = userPool.filter((user) => {
        if (!id && user.IsAssigned === 'Y') return false;
        return true;
      });

      if (currentOperationGrade) {
        filteredUsers = filteredUsers
          .filter((user) => Number(user.Grade) <= Number(currentOperationGrade))
          .sort((a, b) => {
            const aExact = a.Grade === currentOperationGrade;
            const bExact = b.Grade === currentOperationGrade;

            if (aExact && !bExact) return -1;
            if (!aExact && bExact) return 1;
            return b.Grade - a.Grade;
          });
      }

      return filteredUsers;
    }


    // Get all operator IDs from OTHER operations only (excluding current operation)
    const allSelectedOperatorIds = new Set();

    // Add operators from selectedOperatorsMap (only from current line)
    selectedOperatorsMap.forEach((operator) => {
      // Only add operators that are NOT from the current operation AND from the current line
      if (
        Number(operator.operatorId) !== Number(currentOperationOperatorId) &&
        Number(operator.lineId) === Number(currentLineId)
      ) {
        allSelectedOperatorIds.add(operator.operatorId);
      }
    });

    // Add operators from tableData (from ALL lines - both current and other lines)
    operationDetails.forEach((obj, idx) => {
      if (idx !== index && obj.Operatorid != null) {
        // Only add operators that are NOT from the current operation
        // Include operators from ALL lines in tableData
        if (Number(obj.Operatorid) !== Number(currentOperationOperatorId)) {
          allSelectedOperatorIds.add(obj.Operatorid);
        }
      }
    });

    let userPool;
    if (loadAllEmployees[index]) {
      // Use all users from initial data
      userPool = intialUserData;
    } else {
      // Use line-specific users
      userPool = UserData;
    }

    // Filter out operators selected in other rows (from ALL lines in tableData)
    const filteredUsers = userPool.filter((user) => {

      // Exclude operators that are in tableData (regardless of their line)
      if (allSelectedOperatorIds.has(Number(user.UserAccessID))) {
        return false;
      }

      // In new mode, also exclude operators assigned in other forms
      if (!id && user.IsAssigned === 'Y') {
        return false;
      }

      return true;
    });

    // console.log(tableData[index].Operation , filteredUsers, 'filteredUsers before grade filter');

    if (currentOperationGrade) {
      const filteredUsersByGrade = filteredUsers
      .filter((user) => Number(user.Grade) <= Number(currentOperationGrade));

      // Sort: first by whether grade matches current operation grade, then by grade descending
      return filteredUsersByGrade.sort((a, b) => {
        // Priority 1: Operators with exact grade match come first
        const aIsExactMatch = a.Grade === currentOperationGrade;
        const bIsExactMatch = b.Grade === currentOperationGrade;

        if (aIsExactMatch && !bIsExactMatch) return -1;
        if (!aIsExactMatch && bIsExactMatch) return 1;

        // Priority 2: Then sort by grade in descending order
        return b.Grade - a.Grade;
      });
    }
    return filteredUsers;
  };

  // Simplified handleInputChangeUserSelect - no UserData manipulation needed
  // const handleInputChangeUserSelect = (index, newValue) => {
  //   const currentOperationGrade = operationDetails[index]?.GradeId;

  //   // Check if the selected operator meets the grade requirement
  //   if (newValue && !loadAllEmployees[index] && currentOperationGrade && newValue.GradeId > currentOperationGrade) {
  //     alert(`This operator (Grade: ${getGradeLabel(newValue.GradeId)}) cannot be assigned to this operation (Grade: ${getGradeLabel(currentOperationGrade)})`);
  //     return;
  //   }

  //   const updatedDetails = [...operationDetails];
  //   const workingDays = headerData.Weekdays || 26;
  //   const shiftHoursPerDay = shiftHours || 8;
  //   const salaryPerHour = newValue ? newValue.Salary / (workingDays * shiftHoursPerDay) : 0;

  //   const previousOperatorId = operationDetails[index]?.Operatorid;

  //   updatedDetails[index].SalaryPerHour_OnDate = newValue ? salaryPerHour.toFixed(2) : null;
  //   updatedDetails[index].Operatorid = newValue ? Number(newValue.UserAccessID) : null;

  //   // Update selected operators map
  //   setSelectedOperatorsMap(prev => {
  //     let updatedMap = [...prev];

  //     // Remove previous operator if exists
  //     if (previousOperatorId) {
  //       updatedMap = updatedMap.filter(op => op.operatorId !== previousOperatorId);
  //     }

  //     // Add new operator if selected
  //     if (newValue) {
  //       updatedMap.push({
  //         operatorId: newValue.UserAccessID,
  //         lineId: newValue.LineId
  //       });
  //     }

  //     return updatedMap;
  //   });

  //   setOperationDetails(updatedDetails);
  // };
  const handleInputChangeUserSelect = (index, newValue) => {
    const currentOperationGrade = operationDetails[index]?.GradeId;
    const currentRow = operationDetails[index];
    const previousOperatorId = currentRow?.Operatorid;

    // Grade validation (only when checkbox is not checked)
    if (newValue && !loadAllEmployees[index] && currentOperationGrade && newValue.GradeId > currentOperationGrade) {
      alert(
        `This operator (Grade: ${getGradeLabel(
          newValue.GradeId
        )}) cannot be assigned to this operation (Grade: ${getGradeLabel(currentOperationGrade)})`
      );
      return;
    }

    // Assignment status validation for new mode
    if (!id && newValue && newValue.IsAssigned === 'Y') {
      alert('This operator is already assigned to another operation in different form');
      return;
    }

    // Check for duplicate operator selection (excluding current operation's previous operator)
    const exists = selectedOperatorsMap.some(
      (operator) =>
        Number(operator.operatorId) === Number(newValue?.UserAccessID) &&
        Number(operator.operatorId) !== Number(previousOperatorId)
    );

    if (exists && removeDuplicates === 'Y') {
      alert('Operator Already Selected in current form');
      return;
    }

    // Update selected operators map
    setSelectedOperatorsMap((prev) => {
      let updatedMap = [...prev];

      // Remove previous operator if exists
      if (previousOperatorId) {
        updatedMap = updatedMap.filter((op) => Number(op.operatorId) !== Number(previousOperatorId));
      }

      // Add new operator if selected
      if (newValue) {
        // First remove if already exists (to avoid duplicates)
        updatedMap = updatedMap.filter((op) => Number(op.operatorId) !== Number(newValue.UserAccessID));

        updatedMap.push({
          operatorId: newValue.UserAccessID,
          lineId: newValue.LineId,
        });
      }

      return updatedMap;
    });

    // If operator is being removed (set to null), add the previous operator back to userData
    if (!newValue && previousOperatorId) {
      const previousOperator = operationDetails.find((user) => user.UserAccessID === previousOperatorId);

      if (previousOperator) {
        // Check if the previous operator belongs to the current line or if we're showing all employees
        const shouldAddBack = loadAllEmployees[index] || previousOperator.LineId === headerData?.Line_id;

        if (shouldAddBack) {
          setUserData((prevUserData) => {
            const alreadyExists = prevUserData.some((user) => user.UserAccessID === previousOperatorId);
            if (!alreadyExists) {
              return [...prevUserData, previousOperator];
            }
            return prevUserData;
          });
        }
      }
    }

    // Update table data AFTER updating the map
    handleDetailChange(index, 'Operatorid', newValue ? Number(newValue.UserAccessID) : null);

    const updatedDetails = [...operationDetails];
    const workingDays = headerData.Weekdays || 26;
    const shiftHoursPerDay = shiftHours || 8;
    const salaryPerHour = newValue ? newValue.Salary / (workingDays * shiftHoursPerDay) : 0;

    updatedDetails[index].SalaryPerHour_OnDate = newValue ? salaryPerHour.toFixed(2) : null;
    updatedDetails[index].Operatorid = newValue ? Number(newValue.UserAccessID) : null;

    setFieldErrors((prevFieldErrors) => ({
      ...prevFieldErrors,
      [index]: !newValue,
    }));
  };

  return (
    <>
      <Snackbar
        key={alertMessage}
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
        >
          {mdUp && (
            <Box>
              <Link to="/dashboard/manage/time_and_study">
                <Button variant="outlined" color="info" startIcon={<KeyboardBackspaceIcon />}>
                  Back
                </Button>
              </Link>
            </Box>
          )}
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={1}
            pl={2}
            fullWidth
            color="white"
            sx={{
              width: mdUp ? 'inherit' : '100%',
              borderTopLeftRadius: mdUp ? 50 : 50,
              borderBottomLeftRadius: mdUp ? 50 : 50,
              borderTopRightRadius: mdUp ? 0 : 50,
              borderBottomRightRadius: mdUp ? 0 : 50,
              background: 'linear-gradient(to right, #00b09b, #96c93d)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Stack direction={'row'} justifyContent={mdUp ? 'end' : 'center'} alignItems={'center'} spacing={2}>
              {mdUp && <KeyboardDoubleArrowLeftIcon />}
              <Typography variant="h6" color="white" className="font_style1">
                Time & Study
              </Typography>
            </Stack>
          </Typography>
        </Stack>

        <Box sx={{ width: '100%' }}>
          <form onSubmit={handleFormSubmit}>
            <Box sx={{ display: 'flex', flexDirection: 'column', py: 2 }}>
              {!id && (
                <Grid container spacing={2} rowSpacing={2} columnSpacing={2} mb={2}>
                  {id === undefined && (
                    <Grid item xs={12} md={12}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={(e) => {
                          setDialogOpenPicker(true);
                        }}
                      // startIcon={<RepeatOneIcon />}
                      >
                        {!obSelected ? 'Select Operation Bulletin' : 'Change Operation Bulletin'}
                      </Button>
                    </Grid>
                  )}
                </Grid>
              )}
              {/* {obSelected || id
                && ( */}
              <>
                {type === 'View' && (
                  <Button variant="outlined" fullWidth color="error" my={2} sx={{ textTransform: 'uppercase' }}>
                    View-only. No changes allowed
                  </Button>
                )}
                <Divider sx={{ mb: 1, mt: 2 }}>
                  <Chip label="Operational Requirements" size="small" color="warning" />
                </Divider>

                <Stack
                  direction={{ xs: 'row', md: 'row' }}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  spacing={2}
                  mb={2}
                >
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    spacing={2}
                  >
                    <Box>
                      {id && (
                        <Typography variant="h6" color="#1679AB">
                          TS Ref Number : {editRefId}
                        </Typography>
                      )}
                    </Box>
                  </Stack>
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    spacing={2}
                  >
                    <Box>
                      <Typography variant="h6" color="#1679AB">
                        Date : <span>{formatDate(currentDate)}</span>
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>

                <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                  <Grid item md={9} xs={12}>
                    <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                      <Grid item xs={12} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="h6" color="GrayText" pr={1}>
                            Buyer
                          </Typography>
                          <Typography variant="h6" color="#009688">
                            {headerData.Buyer_Name}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="h6" color="GrayText" pr={1}>
                            Garments Description
                          </Typography>
                          <Typography variant="h6" color="#009688">
                            {headerData.Garment_Description}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="h6" color="GrayText" pr={1}>
                            Style Description
                          </Typography>
                          <Typography variant="h6" color="#009688">
                            {headerData.StyleDescription}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="h6" color="GrayText" pr={1}>
                            Style Number
                          </Typography>
                          <Typography variant="h6" color="#009688">
                            {headerData.StyleNumber}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="h6" color="GrayText" pr={1}>
                            Remaining OB QTY
                          </Typography>
                          <Typography variant="h6" color="#009688">
                            {/* {headerData.OrderQty} */}
                            {OBorderQty}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="h6" color="GrayText" pr={1}>
                            Target/Hour
                          </Typography>
                          <Typography variant="h6" color="#009688">
                            {Number.isNaN(headerData.DayTarget / headerData.ShiftHour)
                              ? ''
                              : Math.ceil(headerData.DayTarget / headerData.ShiftHour)}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="h6" color="GrayText" pr={1}>
                            Working Days
                          </Typography>
                          <Typography variant="h6" color="#009688">
                            {headerData.Weekdays}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="h6" color="GrayText" pr={1}>
                            Plan Line Efficiency(%)
                          </Typography>
                          <Typography variant="h6" color="#009688">
                            {headerData.LineEffecient}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        <Stack justifyContent={'flex-start'} direction={'column'}>
                          <Typography variant="h6" color="GrayText" pr={1}>
                            Machine + Handling(%)
                          </Typography>
                          <Typography variant="h6" color="#009688">
                            {headerData.EstimatedEffecient}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Stack direction={'column'} spacing={2}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          border={1}
                          borderRadius={1}
                          borderColor="#e0e0e0"
                          p={1}
                          justifyContent="center"
                        >
                          <Stack direction="row" alignItems="center" justifyContent={'center'} spacing={1}>
                            <Box>
                              <img
                                src={
                                  imagePreview === `${axios.baseURL}OperationBulletin/` ||
                                    imagePreview === null ||
                                    imagePreview === ''
                                    ? NoimageFound
                                    : imagePreview
                                }
                                alt="imgfor"
                                className={classes.chooseFileButton}
                                style={{ maxWidth: '200px', maxHeight: '189px', objectFit: 'contain' }}
                              />
                            </Box>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                      <Grid item xs={12} md={2}>
                        <TextField
                          size="small"
                          type="number"
                          fullWidth
                          label="Order Quantity"
                          value={orderQty}
                          inputProps={{
                            min: 1,
                            step: 1,
                          }}
                          InputProps={{
                            sx: {
                              '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                              '& input[type=number]': {
                                MozAppearance: 'textfield',
                              },
                            },
                          }}

                          onKeyDown={(e) => {
                            if (['-', 'e', 'E', '+', '.'].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}

                          onChange={(e) => {
                            const value = e.target.value;

                            // ✅ EMPTY → show required validation
                            if (value === '') {
                              setOrderQty('');
                              setFieldErrors((prev) => ({
                                ...prev,
                                orderQty: 'Enter order quantity',
                              }));
                              return;
                            }

                            const numericValue = Number(value);

                            // ✅ only positive whole numbers
                            if (!Number.isInteger(numericValue) || numericValue <= 0) {
                              setFieldErrors((prev) => ({
                                ...prev,
                                orderQty: 'Enter a valid positive whole number',
                              }));
                              return;
                            }

                            // ✅ not exceed OB quantity
                            if (numericValue > (Number(OBorderQty) + Number(TSQuantity))) {
                              console.log('numericValue', numericValue);
                              console.log('OBorderQty', OBorderQty);
                              console.log('TSquantity', TSQuantity);
                              setFieldErrors((prev) => ({
                                ...prev,
                                orderQty: `Order quantity cannot exceed OB quantity (${Number(OBorderQty) + Number(TSQuantity)})`,
                              }));
                              return;
                            }

                            // ✅ VALID VALUE
                            setOrderQty(numericValue);
                            setFieldErrors((prev) => ({
                              ...prev,
                              orderQty: '',
                            }));
                          }}

                          error={Boolean(fieldErrors.orderQty)}
                          helperText={fieldErrors.orderQty}
                        />
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <Typography variant="h6" color="#009688">
                          <TextField
                            size="small"
                            type="number"
                            InputProps={{
                              sx: {
                                '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                                {
                                  WebkitAppearance: 'none',
                                  margin: 0,
                                },
                                '& input[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }}
                            fullWidth
                            label="Day Target"
                            value={dayTarget}
                            onChange={(e) => {
                              setDayTarget(e.target.value);
                              setTargetPerHour(e.target.value / shiftHours);
                              setFieldErrors((prevFieldErrors) => ({
                                ...prevFieldErrors,
                                dayTarget: !e.target.value,
                              }));
                              if (operationDetails.length !== 0 && e.target.value !== '') {
                                const newdata = operationDetails.map((data, index) => ({
                                  ...data,
                                  Daytarget: Math.round(Number(data.HoursTarget) * Number(shiftHours)),
                                  NoofOperation: (
                                    Number(e.target.value) / Math.floor(Number(data.HoursTarget) * Number(shiftHours))
                                  ).toFixed(3),
                                  NoofMachines:
                                    Number(e.target.value) / Math.floor(Number(data.HoursTarget) * Number(shiftHours)) <
                                      0.5 &&
                                      Number(e.target.value) / Math.floor(Number(data.HoursTarget) * Number(shiftHours)) >
                                      0
                                      ? 1
                                      : Math.round(
                                        Number(e.target.value) /
                                        Math.floor(Number(data.HoursTarget) * Number(shiftHours))
                                      ).toFixed(3),
                                }));
                                // console.log(newdata);
                                setOperationDetails(newdata);
                              }
                            }}
                            error={fieldErrors.dayTarget}
                            helperText={fieldErrors.dayTarget && 'enter target per day'}
                          />
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="h6" color="#009688">
                          <TextField
                            size="small"
                            type="number"
                            InputProps={{
                              sx: {
                                '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                                {
                                  WebkitAppearance: 'none',
                                  margin: 0,
                                },
                                '& input[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }}
                            fullWidth
                            label="Shift(Hrs)"
                            value={shiftHours}
                            onChange={(e) => {
                              setShiftHours(e.target.value);
                              setTargetPerHour(Math.floor(Number(dayTarget / e.target.value).toFixed(3)));
                              setFieldErrors((prevFieldErrors) => ({
                                ...prevFieldErrors,
                                shiftHours: !e.target.value,
                              }));

                              if (operationDetails.length !== 0 && e.target.value !== '') {
                                const newdata = operationDetails.map((data, index) => ({
                                  ...data,
                                  Daytarget: Math.round(Number(data.HoursTarget) * Number(e.target.value)),
                                  NoofOperation: (
                                    dayTarget / Math.floor(Number(data.HoursTarget) * Number(e.target.value))
                                  ).toFixed(3),
                                  NoofMachines:
                                    dayTarget / Math.round(Number(data.HoursTarget) * Number(e.target.value)) < 0.5 &&
                                      dayTarget / Math.round(Number(data.HoursTarget) * Number(e.target.value)) > 0
                                      ? 1
                                      : Math.round(
                                        (
                                          dayTarget / Math.round(Number(data.HoursTarget) * Number(e.target.value))
                                        ).toFixed(3)
                                      ),
                                }));
                                // console.log(newdata);
                                setOperationDetails(newdata);
                              }
                            }}
                            error={fieldErrors.shiftHours}
                            helperText={fieldErrors.shiftHours && 'enter shift hours'}
                          />
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl size="small" fullWidth component="fieldset" required>
                          <Autocomplete
                            size="small"
                            fullWidth
                            options={unitData}
                            getOptionLabel={(obj) => (obj ? obj.Unit_Name : '')}
                            isOptionEqualToValue={((option, value) => option?.Unit_Id === value?.Unit_Id) ?? undefined}
                            renderInput={(params) => (
                              <TextField {...params} label="Factory Unit" required inputRef={unitRefs} />
                            )}
                            value={unitSelected}
                            disableClearable
                            onChange={(e, newValue) => {
                              setUnitSelected(newValue);
                              GetAllActiveLineMstData(newValue.Unit_Id);
                              setFieldErrors((prevFieldErrors) => ({
                                ...prevFieldErrors,
                                unitSelected: !newValue,
                              }));
                            }}
                          />
                          {fieldErrors.unitSelected && (
                            <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                              Please select production unit
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <FormControl size="small" fullWidth component="fieldset" required>
                          <Autocomplete
                            size="small"
                            fullWidth
                            options={lineData}
                            getOptionLabel={(obj) => (obj ? obj.Line_Name : '')}
                            isOptionEqualToValue={((option, value) => option?.Line_id === value?.Line_id) ?? undefined}
                            renderInput={(params) => (
                              <TextField {...params} label="Batch or Line" required inputRef={lineRefs} />
                            )}
                            value={lineSelected}
                            disableClearable
                            onChange={(e, newValue) => {
                              if (UserData.length > 0 && newValue && newValue.Line_id !== lineSelected?.Line_id && lineSelected !== '') {
                                const shouldProceed = window.confirm(
                                  "Changing the line will clear all assigned operators. Do you want to continue?"
                                );

                                if (!shouldProceed) {
                                  return;
                                }
                              }

                              console.log(newValue);
                              setLineSelected(newValue);

                              if (newValue) {
                                // Filter initialUserData based on line selection
                                const filteredByLine = intialUserData.filter((data) => data.LineId === newValue.Line_id);
                                setUserData(filteredByLine);
                              } else {
                                // Clear user data if no line is selected
                                setUserData([]);
                              }

                              // Clear all selected operators when line changes
                              setSelectedOperators({});

                              // Reset operation details operator IDs
                              setOperationDetails(prevDetails =>
                                prevDetails.map(detail => ({
                                  ...detail,
                                  Operatorid: null,
                                  SalaryPerHour_OnDate: null
                                }))
                              );

                              setFieldErrors((prevFieldErrors) => ({
                                ...prevFieldErrors,
                                lineSelected: !newValue,
                              }));
                            }}
                          // onChange={(e, newValue) => {
                          //   if (UserData.length > 0 && newValue && newValue.Line_id !== lineSelected?.Line_id && lineSelected !== '') {
                          //     const shouldProceed = window.confirm(
                          //       "Changing the line will clear all assigned operators. Do you want to continue?"
                          //     );

                          //     if (!shouldProceed) {
                          //       return;
                          //     }
                          //   }
                          //   setLineSelected(newValue);
                          //   if (newValue) {
                          //     setUserData(intialUserData.filter((data) => data.LineId === newValue.Line_id));
                          //   } else {
                          //     // Clear user data if no line is selected
                          //     setUserData([]);
                          //   }
                          //   setFieldErrors((prevFieldErrors) => ({
                          //     ...prevFieldErrors,
                          //     lineSelected: !newValue,
                          //   }));
                          // }}
                          />
                          {fieldErrors.lineSelected && (
                            <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                              Please select batch or line
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
              {/* )} */}
            </Box>
          </form>
          {/* {obSelected || id
           && ( */}
          <>
            <Divider sx={{ my: 3 }}>
              <Chip label="Operations" size="small" color="warning" />
            </Divider>

            {operationDetails.length > 0 && (
              <>
                <TableContainer
                  component={Paper}
                  elevation={5}
                  sx={{
                    maxHeight: 600,
                    borderRadius: 1,
                    backgroundColor: 'inherit',
                  }}
                >
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <StyledTableHeader align="center">S.No</StyledTableHeader>
                        <StyledTableHeader align="left">Operation</StyledTableHeader>
                        <StyledTableHeader colSpan={2} align="left">
                          M/C Type
                        </StyledTableHeader>
                        <StyledTableHeader align="center">Operator</StyledTableHeader>
                        <StyledTableHeader align="center">
                          <span>Planned SMV</span>
                        </StyledTableHeader>
                        <StyledTableHeader align="center" style={{ whiteSpace: 'nowrap' }}>
                          <span>
                            {' '}
                            Actual <br />
                            SMV
                          </span>
                        </StyledTableHeader>
                        <StyledTableHeader align="center">Hourly Target</StyledTableHeader>
                        <StyledTableHeader align="center">Day Target</StyledTableHeader>
                        <StyledTableHeader align="center">No of Operators</StyledTableHeader>
                        <StyledTableHeader align="center">No of Machines</StyledTableHeader>
                        <StyledTableHeader align="center">Thread Required</StyledTableHeader>
                        <StyledTableHeader align="center">Actions</StyledTableHeader>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {operationDetails.map((obj, index) => (
                        <TableRow
                          key={index}
                          hover
                          sx={{
                            backgroundColor: obj.FinalOperation === 'Y' ? '#EEF5FF' : 'inherit',
                          }}
                        >
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="left" sx={{ textTransform: 'capitalize' }} style={{ whiteSpace: 'nowrap' }}>
                            {obj.FinalOperation === 'Y' ? (
                              <>
                                {obj.OperationName} <br />
                                <Chip
                                  label="final"
                                  size="small"
                                  color="primary"
                                  sx={{ p: 0, m: 0, fontSize: 'x-small', height: 'inherit' }}
                                />
                              </>
                            ) : (
                              obj.OperationName
                            )}
                            <br />
                            <Chip
                              label={`Grade: ${getGradeLabel(obj.GradeId)}`}
                              size="small"
                              variant="outlined"
                              sx={{ fontSize: '0.6rem', height: '20px' }}
                            />
                          </TableCell>
                          <TableCell align="left" colSpan={2} style={{ whiteSpace: 'nowrap' }}>
                            {id ? operationDetails[index].Machine_name : operationDetails[index].Machine_name}
                          </TableCell>

                          <TableCell align="center" style={{ minWidth: '350px' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                              <Autocomplete
                                key={index}
                                size="small"
                                style={{ width: '100%' }}
                                name="group"
                                options={getFilteredUserData(index)}
                                getOptionLabel={(obj) => obj ? `${obj.UserName} (Grade: ${getGradeLabel(obj.GradeId)})` : ''}
                                // disableClearable
                                value={
                                  // Find the selected operator from initialUserData (covers both line-specific and all operators)
                                  intialUserData.find(user => Number(user.UserAccessID) === Number(operationDetails[index].Operatorid)) || null
                                }
                                ref={(el) => {
                                  autocompleteRefs.current[index] = el;
                                }}
                                onChange={(event, newValue) => {
                                  handleInputChangeUserSelect(index, newValue);
                                }}
                                renderInput={(params) => <TextField {...params} label="Select Operator" />}
                                isOptionEqualToValue={(option, value) => option?.UserAccessID === value?.UserAccessID}
                                renderOption={(props, user) => (
                                  <li {...props}>
                                    {`${user.UserName} (Grade: ${getGradeLabel(user.Grade)})`}
                                  </li>
                                )}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    size="small"
                                    checked={loadAllEmployees[index] || false}
                                    onChange={() => handleLoadAllEmployeesToggle(index)}
                                    color="primary"
                                  />
                                }
                                label="Show all available operators (ignore line restriction)"
                                sx={{
                                  m: 0,
                                  '& .MuiFormControlLabel-label': {
                                    fontSize: '0.75rem'
                                  }
                                }}
                              />
                            </Box>
                          </TableCell>

                          <TableCell align="center">{operationDetails[index].Actucalsmv}</TableCell>
                          <TableCell align="center" style={{ minWidth: '120px' }}>
                            <TextField
                              id={`FinalSMV${index}`}
                              size="small"
                              fullWidth
                              type="number"
                              onFocus={(e) => {
                                e.target.select();
                              }}
                              value={operationDetails[index].FinalSMV}
                              onChange={(e) => {
                                handleDetailChange(index, 'FinalSMV', e.target.value);
                              }}
                              onKeyPress={(e) => {
                                if (e.key === 'Enter' && index + 1 <= operationDetails.length - 1) {
                                  document.getElementById(`FinalSMV${index + 1}`).focus();
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell align="center"> {operationDetails[index].HoursTarget}</TableCell>
                          <TableCell align="center"> {operationDetails[index].Daytarget}</TableCell>
                          <TableCell align="center">
                            <TextField
                              onFocus={(e) => {
                                e.target.select();
                              }}
                              id={`NoofOperation${index}`}
                              size="small"
                              fullWidth
                              type="number"
                              InputProps={{
                                sx: {
                                  '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                                  {
                                    WebkitAppearance: 'none',
                                    margin: 0,
                                  },
                                  '& input[type=number]': {
                                    MozAppearance: 'textfield',
                                  },
                                },
                              }}
                              value={operationDetails[index].NoofOperation}
                              onChange={(e) =>
                                UpdateNoofOperation1(index, 'NoofOperation', e.target.value >= 0 && e.target.value)
                              }
                              onKeyPress={(e) => {
                                if (e.key === 'Enter' && index + 1 <= operationDetails.length - 1) {
                                  document.getElementById(`NoofOperation${index + 1}`).focus();
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {operationDetails[index].NoofMachines}
                          </TableCell>
                          <TableCell align="center"> {operationDetails[index].ThirdLength}</TableCell>
                          <TableCell align="center" sx={{ padding: '0' }}>
                            <IconButton aria-label="Delete" onClick={() => handleDeleteOperation(index)}>
                              <DeleteForeverIcon color="error" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
            <Divider sx={{ my: 2 }}>
              <Chip label="Summary" size="small" color="warning" />
            </Divider>
            <Stack justifyContent={'center'} alignItems={'end'} spacing={2} fullWidth mb={1}>
              <Button
                variant="outlined"
                color="inherit"
                size="small"
                onClick={handleMachineDetailsOpen}
                startIcon={<InfoIcon />}
              >
                Machine Details
              </Button>
            </Stack>

            <Grid
              container
              justifyContent={'center'}
              alignItems={'center'}
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              pt={1}
            >
              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Total Man Power
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {operationDetails.reduce((accumulator, currentObject) => {
                        return Number(accumulator) + Number(currentObject.NoofMachines);
                      }, 0)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Work Days
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {workingDays}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      M/C Required
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {operationDetails
                        .filter((data) => data.emp_role === 'O')
                        .reduce((accumulator, currentObject) => {
                          return Number(accumulator) + Number(currentObject.NoofMachines);
                        }, 0)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Total Operator
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {operationDetails
                        .filter((data) => data.emp_role === 'O')
                        .reduce((accumulator, currentObject) => {
                          return Number(accumulator) + Number(currentObject.NoofMachines);
                        }, 0)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Total SMV
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {operationDetails
                        .reduce((accumulator, currentObject) => {
                          return (
                            Number(accumulator) +
                            Number(
                              Number(currentObject.FinalSMV) === 0 || currentObject.FinalSMV === ''
                                ? currentObject.Actucalsmv
                                : currentObject.FinalSMV
                            )
                          );
                        }, 0)
                        .toFixed(3)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Time/Pcs
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {(() => {
                        const result = operationDetails.find((currentObject) => currentObject.FinalOperation === 'Y');
                        return result
                          ? Number(
                            result.FinalSMV === 0 || result.FinalSMV === '' ? result.Actucalsmv : result.FinalSMV
                          ).toFixed(3)
                          : 0;
                      })()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Total Helper
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {operationDetails
                        .filter((data) => data.emp_role === 'H')
                        .reduce((accumulator, currentObject) => {
                          return Number(accumulator) + Number(currentObject.NoofMachines);
                        }, 0)
                        .toFixed(0)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Operator SMV
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {operationDetails
                        .filter((data) => data.emp_role === 'O')
                        .reduce((accumulator, currentObject) => {
                          return (
                            Number(accumulator) +
                            Number(
                              currentObject.FinalSMV === 0 || currentObject.FinalSMV === ''
                                ? currentObject.Actucalsmv
                                : currentObject.FinalSMV
                            )
                          );
                        }, 0)
                        .toFixed(3)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Target/Hour
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {(() => {
                        const result = operationDetails.find((currentObject) => currentObject.FinalOperation === 'Y');
                        return result ? (Number(result.HoursTarget) * Number(result.NoofOperation)).toFixed(3) : '0.00';
                      })()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Shift Hours
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {shiftHours}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Helper SMV
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {operationDetails
                        .filter((data) => data.emp_role === 'H')
                        .reduce((accumulator, currentObject) => {
                          return (
                            Number(accumulator) +
                            Number(
                              currentObject.FinalSMV === 0 || currentObject.FinalSMV === ''
                                ? currentObject.Actucalsmv
                                : currentObject.FinalSMV
                            )
                          );
                        }, 0)
                        .toFixed(3)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Target/Day
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {(() => {
                        const result = operationDetails.find((currentObject) => currentObject.FinalOperation === 'Y');
                        return result
                          ? (Number(result.HoursTarget) * Number(result.NoofOperation)).toFixed(3) * shiftHours
                          : 0;
                      })()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Order Qty
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {orderQty} {'pcs'}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Days Required
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {(orderQty / targetDay).toFixed(3)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Thread Required
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="#009688">
                      <span style={{ marginRight: '4px' }}> : </span>
                      {(
                        operationDetails
                          .reduce((accumulator, currentObject) => {
                            return (
                              Number(accumulator) +
                              Number((Number(currentObject.threadConsumptionFactor) * Number(currentObject.Startch1)).toFixed(2))
                            );
                          }, 0)
                          // .toFixed(0) / 39.37
                          .toFixed(0) / 100
                      ).toFixed(3)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} />

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', pt: 2 }}>
              {type !== 'View' && (
                <Button onClick={handleFormSubmit} color="warning" endIcon={<CheckCircleIcon />} variant="contained">
                  Submit
                </Button>
              )}
            </Box>
          </>
          {/* )} */}
        </Box>
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {/* Select Operation Bulletin */}
      <Dialog open={dialogOpenPicker} onClose={handleDialogClosePicker} maxWidth="md" fullWidth>
        <DialogTitle>Select Operations Bulletin</DialogTitle>
        <DialogContent>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Search"
                size="small"
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
              />
            </FormControl>
          </Stack>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">S.No</TableCell>
                  <TableCell>OB No</TableCell>
                  <TableCell>OB Date</TableCell>
                  <TableCell>Buyer Name</TableCell>
                  <TableCell>Style Description</TableCell>
                  <TableCell>Style No</TableCell>
                  <TableCell>SMV</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredDataPicker.map((obj, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{obj.ObNo}</TableCell>
                    <TableCell align="left">{formatDate(obj.ObDate)}</TableCell>
                    <TableCell align="left">{obj.Buyer_Name}</TableCell>
                    <TableCell align="left">{obj.StyleDescription}</TableCell>
                    <TableCell align="left">{obj.StyleNumber}</TableCell>
                    <TableCell align="left">{obj.SMV}</TableCell>
                    <TableCell align="center" sx={{ padding: '0' }}>
                      <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={() => {
                          setObSelected(obj);
                          // console.log(obj.Obheaderid);
                          setIdState(obj.Obheaderid);
                          setDialogOpenPicker(false);
                        }}
                      >
                        Select
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={handleDialogCloseRepeat} color="secondary">
            Cancel
          </Button>
        </DialogActions> */}
      </Dialog>

      {/* show machine details */}
      <Dialog open={machineDetailsOpen} onClose={handleMachineDetailsClose} maxWidth="xs" fullWidth>
        <DialogTitle>Machine Details</DialogTitle>
        <DialogContent>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell align="left">Machine Type</TableCell>
                  <TableCell align="center">Count</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {machineTypeCounts.map((obj, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{obj.Machine_name}</TableCell>
                    <TableCell align="center">{obj.NoofMachines}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  );
}
